<div
  class="ep-rail"
  [class.ep-is-pinned]="pinned()"
>
  <nav
    class="ep-nav"
    [class.ep-is-open]="open()"
    [class.ep-is-peek]="peek()"
    [attr.aria-label]="'mainNavigation' | translate"
    (mouseenter)="startPeek()"
    (mouseleave)="endPeek()"
    (focusin)="onFocusIn()"
    (focusout)="onFocusOut($event)"
  >
    <div class="ep-items">
      @for (entry of items(); track entry.item.name) {
        @let item = entry.item;
        @if (entry.subItems) {
          <button
            type="button"
            class="ep-row"
            [class.ep-has-active]="isActiveGroup(entry.subItems)"
            [attr.aria-expanded]="open() ? isOpen(item) : null"
            [attr.title]="open() ? null : (item.name | translate)"
            (click)="toggle(item)"
          >
            <ng-container *ngTemplateOutlet="icon; context: { $implicit: item }"></ng-container>
            <span class="ep-label">{{ item.name | translate }}</span>
            <svg
              class="ep-chev"
              [class.ep-is-open]="isOpen(item)"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
            </svg>
          </button>
          @if (open() && isOpen(item)) {
            <div
              class="ep-sub"
              role="group"
              [attr.aria-label]="item.name | translate"
            >
              @for (sub of entry.subItems; track sub.name) {
                @if (sub.href) {
                  <a
                    class="ep-row ep-row--sub"
                    [href]="sub.href"
                    [target]="sub.target"
                    rel="noopener"
                    (click)="onNavigate()"
                  >
                    <span class="ep-label">{{ sub.name | translate }}</span>
                    <svg
                      class="ep-external"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <path
                        d="M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
                      ></path>
                    </svg>
                  </a>
                } @else {
                  <a
                    class="ep-row ep-row--sub"
                    [routerLink]="sub.routeOrFunction"
                    routerLinkActive="ep-is-active"
                    ariaCurrentWhenActive="page"
                    [routerLinkActiveOptions]="{ exact: sub.pathMatchExact || false }"
                    (click)="onNavigate()"
                  >
                    <span class="ep-label">{{ sub.name | translate }}</span>
                  </a>
                }
              }
            </div>
          }
        } @else {
          <a
            class="ep-row"
            [routerLink]="item.routeOrFunction"
            routerLinkActive="ep-is-active"
            ariaCurrentWhenActive="page"
            [routerLinkActiveOptions]="{ exact: item.pathMatchExact || false }"
            [attr.title]="open() ? null : (item.name | translate)"
            (click)="onNavigate()"
          >
            <ng-container *ngTemplateOutlet="icon; context: { $implicit: item }"></ng-container>
            <span class="ep-label">{{ item.name | translate }}</span>
          </a>
        }
      }
    </div>

    @if (open()) {
      <div class="ep-foot">
        <span>
          {{ 'serverVersion' | translate }}: {{ serverVersion() }}
          @if (versionComparison() < 0) {
            <span>*</span>
          }
        </span>
        @if (versionComparison() > 0) {
          <a
            routerLink="/settings/update"
            (click)="onNavigate()"
          >
            {{ 'updateAvailable' | translate }}: {{ latestVersion() }}
          </a>
        }
      </div>
    }
  </nav>
</div>

<ng-template
  #icon
  let-item
>
  @if (item.navIcon) {
    <span
      class="ep-icon ep-icon--svg"
      [style.--icon]="'url(' + item.navIcon + ')'"
      aria-hidden="true"
    ></span>
  } @else {
    <i
      class="ep-icon mdi {{ item.icon }}"
      aria-hidden="true"
    ></i>
  }
</ng-template>
